import React from "react";
import "./Home.scss";
import { setItem } from "../../util/util";
import http from "../../util/api";
import {Toast, Icon, SearchBar } from "antd-mobile";
import qs from "qs";
import Loading from "../../components/Loading";

class Home extends React.Component {
  state = {
    loading:false,
    userData:[],
    event:[
    ]
  };
  async componentDidMount() {
    let token=localStorage.getItem('AccessToken');
    if(token){
      this.getEvents();
    }else{
      this.props.history.push('/login');
    }
  }
  
  getEvents=async()=>{
    this.setState({loading:true});
    try {
      const res = await http().getTable({
        resid:685123321857
      });
      const res2 = await http().getTable({
        resid:685988118358
      });
      const res3 = await http().getTable({
        resid:685126368952,
        cmswhere:`brid = '隐私协议'`
      });
      
      let n =0;
      let arr = res.data.data
      while(n<arr.length){
        if(arr[n].stTime){
          arr[n].stTime=arr[n].stTime.substring(0,arr[n].stTime.length-3);
        }
        if(arr[n].edTime){
          arr[n].edTime=arr[n].edTime.substring(0,arr[n].edTime.length-3);
        }
        n++;
      }
      if(res2.data.data.length>0){
        this.setState({userData:res2.data.data[0]});
        if(res2.data.data[0].agreementVersion!=res3.data.data[0].version){
          Toast.info('隐私协议已经更新，请重新阅读并同意',2);
          this.props.history.push('/agreement?renew=1')
        }
      }
     this.setState({event:res.data.data,loading:false});
    } catch (error) {
      console.error(error);
      if(error.message=='loginerror'){
        this.props.history.push('/login');
      }
      if(error.message=='无权访问该资源。'){
        window.localStorage.clear();
        this.props.history.push('/login');
      }
      this.setState({loading:false});
      Toast.fail(error.message);
    }
  }
  
  render() {
    return (
      <div className="home">
        {this.state.loading?<Loading/>:null}
       <div className='header'>
         <div className='logo' onClick={()=>{
                    this.props.history.push('/');
                  }}>主页</div>
                  <div className='avatar' onClick={()=>{
                    this.props.history.push('/user');
                  }}
                  style={this.state.userData.imgUrl?{backgroundImage:'url('+this.state.userData.imgUrl+')',backgroundPosition:'center',backgroundRepeat:'no-repeat',backgroundSize:'contain'}:{}}
                  
                  ></div>
        <div className='userName'
         onClick={()=>{
          this.props.history.push('/user');
        }}
        >
          {this.state.userData.memberName}
        </div>
         
        </div>
        <ul className='eventList' style={this.state.event.length==1?{marginTop:'calc(50vh - 2.125rem - 50%)'}:{}}>
          {this.state.event.map((item,index)=>{
            return(
              <li key={index} >
                  <div className='showBoard'
                      style={{
                        backgroundImage:'url('+item.bgUrl+')',
                        backgroundRepeat: 'no-repeat',
                        backgroundSize: 'contain',
                        backgroundPosition: '0 1.25rem'
                      }}
                      onClick={()=>{
                        this.props.history.push(item.eventRoute);
                      }}
                  >
                    <p>{item.eventDescription}</p>
                    <div className='time'>
                      <div>
                        开始时间：{item.stTime}
                      </div>
                      <div>
                        结束时间：{item.edTime}
                      </div>
                    </div>
                    <b>查看详情</b>
                  </div>
                  <div className='entrance' onClick={()=>{
                    this.props.history.push(item.eventRoute);
                  }}>
                    <i style={{background:'url('+item.logoUrlWhite+')',backgroundSize:'100%',backgroundRepeat:'no-repeat',backgroundPosition:'center'}}></i>已有{item.attendence}人参与
                  </div>
              </li>
            )
          })}
          
        </ul>
      </div>
    );
  }
}

export default Home;
